module.exports = __webpack_public_path__ + "img/header_logo.1792f1bf.png";